import { render } from "./MultiSelectionChip.vue?vue&type=template&id=51551dce&scoped=true"
import script from "./MultiSelectionChip.vue?vue&type=script&lang=js"
export * from "./MultiSelectionChip.vue?vue&type=script&lang=js"

import "./MultiSelectionChip.vue?vue&type=style&index=0&id=51551dce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51551dce"]])

export default __exports__